import React from "react";

import { AnalyticsDashboardView } from "@src/features/analytics/AnalyticsDashboardView";

import { useShareAnalyticsContext } from "../context/ShareAnalyticsContext";

export const ShareAnalyticsDashboard = () => {
  const {
    experienceFe,
    analyticsData,
    graphConfigs,
    experienceTotals,
    latestRunTs,
    timezone,
    testDuration,
    pageName,
    isLoading,
    dashboardFilters,
  } = useShareAnalyticsContext();

  return (
    <AnalyticsDashboardView
      // Core analytics data
      pageName={pageName}
      analyticsData={analyticsData}
      graphConfigs={graphConfigs}
      experienceTotals={experienceTotals}
      testDuration={testDuration}
      compareVariationId={dashboardFilters.compareVariationId || ""}
      isLoading={isLoading}
      shouldNotRenderGraphs={false}
      // Floating bar data
      latestRunTs={latestRunTs}
      experience={experienceFe}
      timezone={timezone}
      // Feature flags (share view is read-only, no alerts/processes)
      showFloatingBar={true}
      showAiSummary={false}
      showIntegrationsAlert={false}
      showProcesses={false}
    />
  );
};
